import '../styles/ExtractionStepRail.css';
import React from 'react';

const STEPS = [
  { num: '01', label: 'Entry', state: 'Done' },
  { num: '02', label: 'Identity', state: 'Done' },
  { num: '03', label: 'Extraction', state: 'Active' },
  { num: '04', label: 'Leads', state: 'Next' },
];

const ACTIVE_STEP = '03';

function ExtractionStepRail() {
  return (
    <nav className="esr-root" aria-label="Extraction workflow steps" data-content-rail="rail">
      <div className="esr-head">
        <p className="esr-head-label">Process</p>
        <p className="esr-head-meta">
          Step {ACTIVE_STEP} / 04
        </p>
      </div>

      <ol className="esr-list">
        {STEPS.map((step) => {
          const active = step.num === ACTIVE_STEP;
          return (
            <li
              key={step.num}
              className={`esr-item${active ? ' esr-item--active' : ''}`}
              aria-current={active ? 'step' : undefined}
            >
              <span className="esr-num">{step.num}</span>
              <span className="esr-label">{step.label}</span>
              <span className="esr-state">
                <span className="esr-dot" aria-hidden="true" />
                {step.state}
              </span>
            </li>
          );
        })}
      </ol>

      <p className="esr-foot">
        Extraction runs here. Completed runs are saved and reachable from Leads.
      </p>
    </nav>
  );
}

export default ExtractionStepRail;